import React, { useState } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  isPlatform,
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonIcon,
  IonButton,
  IonInput
} from "@ionic/react";
import "./References.scss";
import i18n from "../../../../../i18n";
import { useDispatch } from "react-redux";
import { AddReferences } from "app/models/myLoad/tenderAction.model";
import { addReference } from "app/actions/carrierTendered/action";
import { CustomModalWeb } from "app/web/pages/userProfile/CustomModalWeb";
import { isAddReferencesVisible, referencesDropdownButtons } from "app/utils/sourceTMSAndDivisionFilter";
import { ADD_REFERENCE_SUCCESS, ALL_FIELDS_REQUIRED_TEXT, REFERENCE_ACTION_DETAIL, REFERENCE_ACTION_TYPE, REFERENCE_TYPE_HEADER_MESSAGE, REFERENCE_TYPE_MESSAGE, REFERENCE_VALUE_PLACEHOLDER_MESSAGE } from "app/utils/constants";
import { getCurrentDatewithTimeZone, getCustomer } from "app/pages/LoadDetails/loadDetailsUtil";
import { isDriverRoleOnly, isLeasedOwnerOprRoleOnly ,isDispatcherRole} from "../../../../utils/roleUtil/RoleUtil";
import { logEvent } from "app/utils/Analytics";
import { EVENT, SCREEN } from "app/utils/constants.analytics";
import { ToastMessage } from "../../../../utils/ToastMessage";

export interface ComponentProps {
  references: any[];
  props: any;
}

export default ({ references, props }: ComponentProps) => {
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");
  const paddingClass = isMobile ? "mobile-padding" : "web-padding";
  const [referenceModal, setReferenceModal] = React.useState(false);
  const [addReferenceModal, setAddReferenceModal] = React.useState(false);
  const [showOptions, setShowOptions] = useState<number | null>(null);
  const [selectedDropdown, setSelectedDropdown] = React.useState([{ refType: '', refVal: ''}]);
  const [showToast, setShowToast] = React.useState(false);
  const [isError, setIsError] = useState<string | null>(null);

  const dispatch = useDispatch();
  const addReferencesOptions = referencesDropdownButtons(props?.sourceTMS,props?.division)?.sort();
  const closeToast = () => {
    if(isMobile){
      ToastMessage.show(ADD_REFERENCE_SUCCESS)
    } else {
      ToastMessage.showWeb(ADD_REFERENCE_SUCCESS)
    }
    setTimeout(()=>{
      setShowToast(false);
    },5000)
  };
  const addReferenceProps = {
    isModalOpen:  !!addReferenceModal,
    title: "Add Reference",
    contentAlignment: "center",
    aditionalCssClass : "",
    size: "medium_small",
    contentScroll: "allow",
    backdropDismiss:false,
    buttons: [
      {
        title: i18n.t('Cancel'),
        type: "secondary-cta-btn-web",
        onClick: () => {
          setAddReferenceModal(false);
          setSelectedDropdown([{ refType: '', refVal: ''}]);
          logEvent(EVENT.UE_ADD_REFERENCE_CANCEL, {
            screen: SCREEN.ADD_REFERENCE_MODAL,
            carrierId: props?.carrierId,
            shipmentId: props?.shipmentId,
            stopId: ""
          });
        }
      },
      {
        title: i18n.t('Confirm'),
        type: "primary-cta-btn-web",
        isDisabled: selectedDropdown.some((item) => item.refType === '' || item.refVal === '') ? true : false,
        onClick: () => {
          setIsError(null);
          setAddReferenceModal(false);
          const _model: any = new AddReferences();
          _model.shipmentId = props?.shipmentId;
          _model.sourceSystem = props?.sourceTMS;
          _model.eventDateTime = getCurrentDatewithTimeZone(props?.loadStop);
          _model.customer = getCustomer(props?.shipmentInvolvedParties);
          _model.assignmentStatus = props?.assignmentStatus;
          _model.actionType = REFERENCE_ACTION_TYPE;
          _model.actionQualifier = selectedDropdown[0]?.refType;
          _model.actionDetail = REFERENCE_ACTION_DETAIL;
          _model.shipmentState = props?.shipmentState || null;
          _model.actionDateTime = null;
          _model.referenceType = selectedDropdown[0]?.refType;
          _model.referenceValue = selectedDropdown[0]?.refVal;
          logEvent(EVENT.UE_ADD_REFERENCE_CONFIRM, {
            screen: SCREEN.ADD_REFERENCE_MODAL,
            carrierId: props?.carrierId,
            shipmentId: props?.shipmentId,
            stopId: ""
          });
          dispatch(addReference(_model.getAddReferenceActionPayload(),false, async (response: any) => {
          if (response.message === ADD_REFERENCE_SUCCESS) {
            setShowToast(true); //on true response
            props.clickDownArrowAction();
            logEvent(EVENT.UE_ADD_REFERENCE_SUCCESS, {
              screen: SCREEN.ADD_REFERENCE_MODAL,
              carrierId: props?.carrierId,
              shipmentId: props?.shipmentId,
              stopId: ""
            });
          } else {
            logEvent(EVENT.UE_ADD_REFERENCE_FAILURE, {
              screen: SCREEN.ADD_REFERENCE_MODAL,
              carrierId: props?.carrierId,
              shipmentId: props?.shipmentId,
              stopId: ""
            });
          }
          }));
          setSelectedDropdown([{ refType: '', refVal: ''}]);
        }
      }
    ]
  };

  const onConfirm = (option: any, refIndex: number) => {
    const onChangeOption = [...selectedDropdown];
    onChangeOption[refIndex].refType = option;
    setSelectedDropdown(onChangeOption);
    setShowOptions(null);
    isError && errorCheckHandler();
  };

  const handleChange = (e?: any,i?:any) => {
    const {value} = e.target;
    const onChangeVal = [...selectedDropdown];
    onChangeVal[i].refVal=value;
    setSelectedDropdown(onChangeVal);
    errorCheckHandler();
  };

  const closeReferenceModal = (): void => {
    setReferenceModal(false);
  };

  const errorCheckHandler = () => {
    const hasEmptyFields = selectedDropdown.some((item) => item.refType === '' || item.refVal === '');
    if (hasEmptyFields) {
      if (selectedDropdown[selectedDropdown.length - 1].refType === '') {
        selectedDropdown.some((item) => item.refType === '' && item.refVal === '') ? setIsError(null) : setIsError('TypeError');
      } else if (selectedDropdown[selectedDropdown.length - 1].refVal === '') {
        setIsError('ValueError');
      }
    } else {
      setIsError(null);
    }
  };

  return (
    <>
      <div className="references-component">
        <CustomModalWeb {...addReferenceProps}>
          <IonGrid className="reference-modal-grid">
            <IonRow className="reference-heading">
              <div className="reference-type-heading">{REFERENCE_TYPE_HEADER_MESSAGE}</div>
              {selectedDropdown.map((value, i: number) => (
                <IonRow key={i} className="reference-head">
                  <IonCol size="6">
                    <div className="ref-type">{"Select Type"}</div>
                    <IonButton
                      className={`dropdown-button ${isError === 'TypeError' ? "error-border" : ""}`}
                      data-test="reference-type"
                      onClick={() => {
                        setShowOptions(i);
                      }}>
                      <span className={`${value?.refType ? "selected-dropdown-name" : "placeholder" }`}>{value?.refType ? `${value.refType}` : REFERENCE_TYPE_MESSAGE}</span>
                      <i className="down"></i>
                    </IonButton>
                  </IonCol>
                  <IonCol size="6">
                    <div className="ref-value">{"Select Value"}</div>
                    <IonInput
                      type="text"
                      className={`reference-input ${isError === 'ValueError' ? "error-border" : ""}`}
                      placeholder={REFERENCE_VALUE_PLACEHOLDER_MESSAGE}
                      name={"referenceValue"}
                      maxlength={25}
                      onIonChange={(e: any) => { handleChange(e,i) }}
                      value={value?.refVal}
                    ></IonInput>
                  </IonCol>
                </IonRow>))}
              {(showOptions !== null) ? (
                <div className="dropdown-list" data-test="dropdown-options" onMouseLeave={() => setShowOptions(null)}>
                  {addReferencesOptions.map((option: any, k: any) => (
                    <IonRow data-test="dropdown-row" key={k} onClick={() => { onConfirm(option, showOptions) }}>
                      <IonCol>{option}</IonCol>
                    </IonRow>
                  ))}
                </div>
              ) : null}
              {isError && <span className="red-error">{ALL_FIELDS_REQUIRED_TEXT}</span>}
            </IonRow>
          </IonGrid>
        </CustomModalWeb>
        {!!references.length ? references.length === 1 ? references[0].display ? (
          <div className="references">
            <IonCard
              class={`details-references-component ${isMobile ? "" : "webBorder"}`}
            >
              <IonCardTitle
                className="title"
                data-test="title"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                <IonCol size="7">{i18n.t("References Details")}</IonCol>
                {(isAddReferencesVisible(props?.sourceTMS,props?.division) && (isLeasedOwnerOprRoleOnly() || isDispatcherRole() || isDriverRoleOnly())) && 
                <IonCol size="5" className="add-references"
                  onClick={() => {
                    closeReferenceModal();
                    setAddReferenceModal(true);
                    setIsError(null);
                    logEvent(EVENT.SV_ADD_REFERENCE, {
                      screen: SCREEN.ADD_REFERENCE_MODAL,
                      shipmentId: props?.shipmentId,
                      stopId: ""
                    });
                  }}
                >
                <IonIcon
                  className="add-ref-icon"
                  src="assets/icon/reference-template.svg"
                />
                <span>{i18n.t("Add Reference")}</span>
                </IonCol>}
              </IonCardTitle>
              <IonCardContent>
                <IonGrid className="references-title-component">
                  <IonRow>
                    <IonCol data-test="Reference-Type" className={paddingClass}>
                      {i18n.t("Reference Type")}
                    </IonCol>
                    <IonCol data-test="Reference-Value" className={paddingClass}>
                      {i18n.t("Reference Value")}
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <div className="reference-item-container">
                  {references.map((ref: any, index: number) => (
                    ref?.display && <IonGrid
                      className="references-component"
                      key={`${ref.type}_${index}`}
                    >
                      <IonRow>
                        <IonCol
                          data-test="description"
                          className={paddingClass}
                        >
                          {ref.type}
                        </IonCol>
                        <IonCol
                          data-test="packaging-type"
                          className={paddingClass}
                        >
                          {ref.value}
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  ))}
                </div>
              </IonCardContent>
            </IonCard>
          </div>
        ) : <IonCard class="no-references-found">
        <IonCardContent>
          <div>{i18n.t("noReferencesText")}</div>
        </IonCardContent>
      </IonCard> :(
          <div className="references">
            <IonCard
              class={`details-references-component ${isMobile ? "" : "webBorder"}`}
            >
              <IonCardTitle
                className="title"
                data-test="title"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                <IonCol size="7">{i18n.t("References Details")}</IonCol>
                {(isAddReferencesVisible(props?.sourceTMS,props?.division) && (isLeasedOwnerOprRoleOnly() || isDispatcherRole() || isDriverRoleOnly())) && 
                <IonCol size="5" className="add-references"
                  onClick={() => {
                    closeReferenceModal();
                    setAddReferenceModal(true);
                    setIsError(null);
                    logEvent(EVENT.SV_ADD_REFERENCE, {
                      screen: SCREEN.ADD_REFERENCE_MODAL,
                      shipmentId: props?.shipmentId,
                      stopId: ""
                    });
                  }}
                >
                <IonIcon
                  className="add-ref-icon"
                  src="assets/icon/reference-template.svg"
                />
                <span>{i18n.t("Add Reference")}</span>
                </IonCol>}
              </IonCardTitle>
              <IonCardContent>
                <IonGrid className="references-title-component">
                  <IonRow>
                    <IonCol data-test="Reference-Type" className={paddingClass}>
                      {i18n.t("Reference Type")}
                    </IonCol>
                    <IonCol data-test="Reference-Value" className={paddingClass}>
                      {i18n.t("Reference Value")}
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <div className="reference-item-container">
                  {references.map((ref: any, index: number) => (
                    ref?.display && <IonGrid
                      className="references-component"
                      key={`${ref.type}_${index}`}
                    >
                      <IonRow>
                        <IonCol
                          data-test="description"
                          className={paddingClass}
                        >
                          {ref.type}
                        </IonCol>
                        <IonCol
                          data-test="packaging-type"
                          className={paddingClass}
                        >
                          {ref.value}
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  ))}
                </div>
              </IonCardContent>
            </IonCard>
          </div>
        ) : (
            <>
              {(isAddReferencesVisible(props?.sourceTMS, props?.division) && (isLeasedOwnerOprRoleOnly() || isDispatcherRole() || isDriverRoleOnly())) &&
                <IonRow className="reference-header">
                  <IonGrid className="add-references-web" data-test="add-reference-button" onClick={() => {
                    closeReferenceModal();
                    setAddReferenceModal(true);
                    setIsError(null);
                    logEvent(EVENT.SV_ADD_REFERENCE, {
                      screen: SCREEN.ADD_REFERENCE_MODAL,
                      shipmentId: props?.shipmentId,
                      stopId: ""
                    });
                  }}>
                    <IonIcon
                      className="add-ref-icon"
                      src="assets/icon/reference-template.svg"
                    />
                    <div>{i18n.t("Add Reference")}</div>
                  </IonGrid>
                </IonRow>}
              <IonCard class="no-references-found">
                <IonCardContent>
                  <div>{i18n.t("noReferencesText")}</div>
                </IonCardContent>
              </IonCard>
            </>
        )}
        {(props?.shipmentAndStopReferences?.length !== 0 && showToast) ? closeToast() : null}
      </div>
    </>
  );
};
